import $ from 'jquery';
import '../vendors/biggerlink';

$(document).ready(function() {
  $('.biggerlink').biggerlink();
});
